/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Version/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Version({
  children,
  viewPath = "/App/Account/Topbar/Version"
  
}) {
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let appVersionValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'version',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Version.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-2nBW40': dtColorsNeutral800}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 cursor="default"
 fontSize={8}
 color={dtColorsNeutral400}
 data="app.version"
 text={appVersionValueData}
/>
</div>
{children}
</React.Fragment>)
}